import { Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router-dom";

import { CodePostalApi } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../../components";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import { CodePostalDetailPage } from "./CodePostalDetailPage";

interface ICodePostalItemPageProps {}

export const CodePostalItemPage: React.FunctionComponent<ICodePostalItemPageProps> = () => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();

  const codePostalApi = useApiService(CodePostalApi);
  const [displayName] = useApiEffect(() => codePostalApi.codePostalGetDisplayName({ id: +id }), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.CodesPostaux), route: ERoutes.codePostal },
        { text: +id <= 0 ? t(ETLCodes.New) : displayName }
      ]}
    >
      <ProtectedTabs
        id="TabsCodePostal"
        onChange={newTabId => history.push(`${ERoutes.codePostal}/${id}/${newTabId}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.codePostal}></BackButton>
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<CodePostalDetailPage idCodePostal={id} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
